export default __webpack_public_path__ + "static/media/Bucket_Issue.fc9f6bd7.svg";